import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { RegistryActions } from './registry.action';
import { RegistryStateModel } from './registry.store';
import { FilterModel } from 'ag-grid-community';
import { RegistryFirestoreService } from '../../services/registry.firestore.service';

@State<RegistryStateModel>({
  name: 'registrys',
  defaults: {
    registry: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class RegistryState {
  private registryService = inject(RegistryFirestoreService);
  // private userState = inject(RegistryState);
  // private dbUser = inject(OrmService).registryCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(RegistryActions.GetAllRegistry)
  async getAllRegistryss(ctx: StateContext<RegistryStateModel>) {
    ctx.patchState({ isLoading: true });
    const registry = await this.registryService.GetAll();
    ctx.patchState({
      registry: registry.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(RegistryActions.UpdateRegistry)
  async updateRegistrys(
    ctx: StateContext<RegistryStateModel>,
    { registryData, ref: id }: RegistryActions.UpdateRegistry,
  ) {
    await this.registryService.Update(id, registryData);
  }

  @Action(RegistryActions.PaginateQueryRegistry)
  async queryRegistrys(
    ctx: StateContext<RegistryStateModel>,
    { request, isResetAfterFilterOrSort }: RegistryActions.PaginateQueryRegistry,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(RegistryState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.registryService.SetQuery({
      ...request,
      count: state.registry.length,
      data: state.registry,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.registry.length;
      state.registry = [];
      state.registry.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.registry = [];
      state.registry.length = await this.registryService.GetBuildedCount(runs);
    }
    if (state.registry.length !== 0) {
      runs.push(...this.registryService.SetLimit({ ...request, count: state.registry.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const registry = await this.registryService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        registry.reverse().forEach(
          ({ data, ref }, i) =>
            (state.registry[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        registry.forEach(
          ({ data, ref }, i) =>
            (state.registry[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, registry: state.registry });
  }

  @Action(RegistryActions.RegistryError)
  registrysError(ctx: StateContext<RegistryStateModel>, { error }: RegistryActions.RegistryError) {
    console.error({ error });
    // await this.registryService.Update(id, registrysData);
  }

  @Action(RegistryActions.DeleteRegistrys)
  async deletetRegistryss(ctx: StateContext<RegistryStateModel>, { refs }: RegistryActions.DeleteRegistrys) {
    await this.registryService.BatchDelete(refs);
  }

  @Action(RegistryActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<RegistryStateModel>,
    { fields, timePeriod, filterModel }: RegistryActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (userId) {
    //   filterModel = { userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.registryService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.registryService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.registryService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static registrys(state: RegistryStateModel) {
    return state.registry;
  }
  @Selector()
  static registrysCount(state: RegistryStateModel) {
    return state.registry.length;
  }

  @Selector()
  static sums(state: RegistryStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: RegistryStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static registryState(state: RegistryStateModel) {
    return state;
  }

  @Selector()
  static getFilter(state: RegistryStateModel) {
    return state.filter;
  }
}
